import Image from 'next/image';
import { FC } from 'react';
import Slider from 'react-slick';

const testimonialsData = [
  {
    name: 'Dineo Mabatha',
    image: '/images/testimonials/Reviewer-1.webp',
    content:
      "Simple and easy to use website and mobile app. As a female car parts & tyres can be confusing but Car Spares EzyFind made it easy for me. I scanned my license disc and took a picture of the Tyre. I then send one request and obtained multiple quotes to select from for the correct tyre size.",
  },
  {
    name: 'Tsheko Tselo',
    image: '/images/testimonials/Reviewer-2.webp',
    content:
      "Awesome mobile auto EzyFind app. Will definitely recommend to any vehicle owner as a must have app for all your auto products and services.",
  },
  {
    name: 'Alan Hueg',
    image: '/images/testimonials/Reviewer-3.webp',
    content:
      'Fully automated any Queue for you services from vehicle license renewals to traffic fines etc. Your one stop website and mobile app for iPhone, Android and Huawei. The process was simple and very pleasant. Thank you Car Spares EzyFind.',
  },
  {
    name: 'Glen Aboo',
    image: '/images/testimonials/Reviewer-4.webp',
    content:
      'Awesome website & mobile app to SELL all my vehicle spares on this simple eCommerce platform.',
  },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
};

const Testimonials: FC = () => {
  return (
    <Slider {...sliderSettings} className="lg:w-[800px] m-auto text-center px-4">
      {testimonialsData.map((testimonial, index) => (
        <div key={index}>
          <Image
            src={testimonial.image}
            width={100}
            height={100}
            alt={testimonial.name}
            className="m-auto rounded-full border-8 border-white shadow-xl mb-3"
          />
          <p className="text-2xl text-primary font-bold mb-4">{testimonial.name}</p>
          <p className="text-sm lg:text-base text-gray-700 leading-relaxed">{testimonial.content}</p>
        </div>
      ))}
    </Slider>
  );
};

export default Testimonials;
